import axios from "axios";
import { ChevronDownIcon, ChartBarIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Pagination } from "../../helper/HelperTwo";

function EmployeeWorkRelatedList({}) {
  const location = useLocation();
  const { id_crypt } = location.state;

  const [activeTab, setActiveTab] = useState("Leads");
  const [workRelated, setWorkRelated] = useState([]);
  const [filterParams, setFilterParams] = useState("");

  const fetchEmployeeworkRelatedData = async (page = 1, queryParams = "") => {
    try {
      const token = localStorage.getItem("token");

      const apiUrl = `public/api/admin/employees/getEmployeedetails/${id_crypt}?page=${page}${
        queryParams ? `&${queryParams}` : ""
      }`;

      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

   

      setWorkRelated(response.data);
    } catch (error) {
      console.error("Error fetching employee work-related data:", error);
    }
  };

  useEffect(() => {
    fetchEmployeeworkRelatedData();
  }, []);

    const handlePageChangeForLeads = (page) => {
      if (page !== "..." && !isNaN(page)) {
        const newPage = Number(page);

        fetchEmployeeworkRelatedData(newPage, filterParams);
      }
    };

    const handlePageChangeForTasks = (page) => {
      if (page !== "..." && !isNaN(page)) {
        const newPage = Number(page);

        fetchEmployeeworkRelatedData(newPage, filterParams);
      }
    };

    const handlePageChangeForQuotations = (page) => {
      if (page !== "..." && !isNaN(page)) {
        const newPage = Number(page);

        fetchEmployeeworkRelatedData(newPage, filterParams);
      }
    };

  return (
    <>
      <button
        onClick={() => window.history.back()}
        className="px-4 py-2 sm:px-5 sm:py-2.5 bg-gray-500 text-white sm:text-xs text-xs font-semibold rounded-lg shadow-md transition-all duration-200 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
      >
        ← Back
      </button>

      <div className=" pb-5 sm:pb-0 mt-4">
        <h3 className="text-base font-bold text-indigo-700 py-2 rounded-md shadow-sm">
          Employee:{" "}
          <span className="text-gray-900 uppercase">{workRelated.employee}</span>
        </h3>

        <div className="p-4 bg-white rounded-md">
          {/* Tab Navigation */}
          <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
            <div className="block">
              <div className="overflow-x-auto scroll-hidden">
                <nav className="flex space-x-8">
                  {["Leads", "Tasks", "Quotations"].map((tab) => (
                    <button
                      key={tab}
                      onClick={() => setActiveTab(tab)}
                      className={`px-4 pb-3 text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                        activeTab === tab
                          ? "border-b-2 border-indigo-500 text-indigo-600"
                          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                      }`}
                    >
                      {tab}
                    </button>
                  ))}
                </nav>
              </div>
            </div>
          </div>

          {/* Tab Content */}
          <div className="mt-4 p-4">
            <div className="overflow-x-auto">
              {activeTab === "Leads" && (
                <>
                  <table className="min-w-full border border-gray-300 shadow-sm rounded-lg overflow-hidden">
                    <thead className="bg-gray-100 text-gray-700">
                      <tr>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          S No
                        </th>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          Lead Name
                        </th>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          Date
                        </th>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {workRelated?.lead_details?.data?.length > 0 ? (
                        workRelated.lead_details.data.map((lead, index) => (
                          <tr
                            key={lead.id}
                            className="hover:bg-gray-100 transition-all duration-200"
                          >
                            <td className="py-3 px-5 border-b text-gray-800 text-sm sm:text-base">
                              {workRelated?.lead_details?.from
                                ? workRelated.lead_details.from + index
                                : "N/A"}
                            </td>
                            <td className="py-3 px-5 border-b text-gray-800 text-sm sm:text-base">
                              {lead?.name || "N/A"}
                            </td>
                            <td className="py-3 px-5 border-b text-gray-800 text-sm sm:text-base">
                              {lead?.date
                                ? lead.date
                                    .split(" ")[0]
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                : "N/A"}
                            </td>
                            <td className="py-3 px-5 border-b">
                              <span
                                className={`px-3 py-1.5 rounded text-xs sm:text-base font-medium shadow-sm ${
                                  lead?.lead_status?.name === "Completed"
                                    ? "bg-green-100 text-green-800 border border-green-300"
                                    : lead?.lead_status?.name === "Pending"
                                    ? "bg-yellow-100 text-yellow-800 border border-yellow-300"
                                    : "bg-blue-100 text-blue-800 border border-blue-300"
                                }`}
                              >
                                {lead?.lead_status?.name || "N/A"}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="4"
                            className="py-4 px-5 text-center text-gray-500"
                          >
                            No leads available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>


                  {workRelated?.lead_details?.data?.length > 0 && (
                    <Pagination
                      links={workRelated.lead_details.links || []}
                      currentPage={workRelated.lead_details.current_page || 1}
                      totalResults={workRelated.lead_details.total || 0}
                      from={workRelated.lead_details.from || 0}
                      to={workRelated.lead_details.to || 0}
                      lastPage={workRelated.lead_details.last_page || 1}
                      onPageChange={handlePageChangeForLeads}
                    />
                  )}
                </>
              )}

              {activeTab === "Tasks" && (
                <>
                  <table className="min-w-full border border-gray-300 shadow-sm rounded-lg overflow-hidden">
                    <thead className="bg-gray-100 text-gray-700">
                      <tr>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          S No
                        </th>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          Task Name
                        </th>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          Start Date
                        </th>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          End Date
                        </th>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {workRelated?.task_details?.data?.length > 0 ? (
                        workRelated.task_details.data.map((task, index) => (
                          <tr
                            key={task.id}
                            className="hover:bg-gray-100 transition-all duration-200"
                          >
                            <td className="py-3 px-5 border-b text-gray-800 text-sm sm:text-base">
                              {workRelated?.task_details?.from
                                ? workRelated.task_details.from + index
                                : "N/A"}
                            </td>
                            <td className="py-3 px-5 border-b text-gray-800 text-sm sm:text-base">
                              {task?.task_name || "N/A"}
                            </td>
                            <td className="py-3 px-5 border-b text-gray-800 text-sm sm:text-base">
                              {task?.start_date
                                ? task.start_date.split("-").reverse().join("-")
                                : "N/A"}
                            </td>
                            <td className="py-3 px-5 border-b text-gray-800 text-sm sm:text-base">
                              {task?.end_date
                                ? task.end_date.split("-").reverse().join("-")
                                : "N/A"}
                            </td>
                            <td className="py-3 px-5 border-b">
                              <span
                                className={`px-3 py-1.5 rounded text-xs sm:text-base font-medium shadow-sm ${
                                  task?.task_status_name?.name === "Completed"
                                    ? "bg-green-100 text-green-800 border border-green-300"
                                    : task?.task_status_name?.name === "Pending"
                                    ? "bg-yellow-100 text-yellow-800 border border-yellow-300"
                                    : "bg-blue-100 text-blue-800 border border-blue-300"
                                }`}
                              >
                                {task?.task_status_name?.name || "N/A"}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="5"
                            className="py-4 px-5 text-center text-gray-500"
                          >
                            No tasks available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {workRelated?.task_details?.data?.length > 0 && (
                    <Pagination
                      links={workRelated.task_details.links || []}
                      currentPage={workRelated.task_details.current_page || 1}
                      totalResults={workRelated.task_details.total || 0}
                      from={workRelated.task_details.from || 0}
                      to={workRelated.task_details.to || 0}
                      lastPage={workRelated.task_details.last_page || 1}
                      onPageChange={handlePageChangeForTasks}
                    />
                  )}
                </>
              )}

              {activeTab === "Quotations" && (
                <>
                  <table className="min-w-full border border-gray-300 shadow-sm rounded-lg overflow-hidden">
                    <thead className="bg-gray-100 text-gray-700">
                      <tr>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          S No
                        </th>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          Quotation No
                        </th>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          Date
                        </th>
                        <th className="py-3 px-5 border-b text-left text-sm sm:text-base font-semibold">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {workRelated?.quotations?.data?.length > 0 ? (
                        workRelated.quotations.data.map((quotation, index) => (
                          <tr
                            key={quotation.id}
                            className="hover:bg-gray-100 transition-all duration-200"
                          >
                            <td className="py-3 px-5 border-b text-gray-800 text-sm sm:text-base">
                              {workRelated?.quotations?.from
                                ? workRelated.quotations.from + index
                                : "N/A"}
                            </td>
                            <td className="py-3 px-5 border-b text-gray-800 text-sm sm:text-base">
                              {quotation?.quotation_number || "N/A"}
                            </td>
                            <td className="py-3 px-5 border-b text-gray-800 text-sm sm:text-base">
                              {quotation?.quotation_date
                                ? quotation.quotation_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                : "N/A"}
                            </td>
                            <td className="py-3 px-5 border-b">
                              <span
                                className={`px-3 py-1.5 rounded text-xs sm:text-base font-medium shadow-sm ${
                                  quotation?.quotation_status?.name ===
                                  "Completed"
                                    ? "bg-green-100 text-green-800 border border-green-300"
                                    : quotation?.quotation_status?.name ===
                                      "Pending"
                                    ? "bg-yellow-100 text-yellow-800 border border-yellow-300"
                                    : "bg-red-100 text-red-800 border border-red-300"
                                }`}
                              >
                                {quotation?.quotation_status?.name || "N/A"}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="4"
                            className="py-4 px-5 text-center text-gray-500"
                          >
                            No quotations available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {workRelated?.quotations?.data?.length > 0 && (
                    <Pagination
                      links={workRelated.quotations.links || []}
                      currentPage={workRelated.quotations.current_page || 1}
                      totalResults={workRelated.quotations.total || 0}
                      from={workRelated.quotations.from || 0}
                      to={workRelated.quotations.to || 0}
                      lastPage={workRelated.quotations.last_page || 1}
                      onPageChange={handlePageChangeForQuotations}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployeeWorkRelatedList;
